import { render, staticRenderFns } from "./GradedJournalEntry.vue?vue&type=template&id=7e82080f&scoped=true&"
import script from "./GradedJournalEntry.vue?vue&type=script&lang=js&"
export * from "./GradedJournalEntry.vue?vue&type=script&lang=js&"
import style0 from "./GradedJournalEntry.vue?vue&type=style&index=0&id=7e82080f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e82080f",
  null
  
)

export default component.exports